import { queryOptions } from '@tanstack/react-query';
import { articlesApi, type ArticleListQuery } from '@shared/api';

const knowledgeMonitorInterval = 2000;

export const articleKeys = {
  all: (scope: string) => ['helpdesk-articles', scope] as const,
  lists: (scope: string) => [...articleKeys.all(scope), 'list'] as const,
  detail: (scope: string, id: string) => [...articleKeys.all(scope), 'detail', id] as const,
};

export const articleListQuery = (scope: string, params: ArticleListQuery) =>
  queryOptions({
    queryKey: [...articleKeys.lists(scope), params],
    queryFn: ({ signal }) => articlesApi.list(params, signal),
    enabled: scope.length > 0,
    refetchInterval: (query) =>
      !query.state.error && query.state.data?.meta.knowledge.state === 'pending'
        ? knowledgeMonitorInterval
        : false,
    refetchIntervalInBackground: false,
    placeholderData: (previousData, previousQuery) =>
      scope.length > 0 &&
      previousQuery?.queryKey[0] === 'helpdesk-articles' &&
      previousQuery.queryKey[1] === scope &&
      previousQuery.queryKey[2] === 'list'
        ? previousData
        : undefined,
    retry: false,
    staleTime: 0,
  });

export const articleDetailQuery = (scope: string, id: string) =>
  queryOptions({
    queryKey: articleKeys.detail(scope, id),
    queryFn: ({ signal }) => articlesApi.detail(id, signal),
    retry: false,
    staleTime: 0,
  });
